import React from 'react';
import { GlobalProvider, useGlobalContext } from './context/globalContext';
import { Toaster } from './components/ui/toaster';
import { Theme } from '@chakra-ui/react';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/authContext';
import { useSiteBootstrap } from './hooks/useSiteBootstrap';

function AppContent() {
  const { colorMode } = useGlobalContext();
  useSiteBootstrap();
  return (
    <Theme appearance={colorMode}>
      <div id='portal-root' />
      <AppRoutes />
      <Toaster />
    </Theme>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <GlobalProvider>
        <AppContent />
      </GlobalProvider>
    </AuthProvider>
  );
}
